export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 max-w-xl">
            <div className="flex items-center gap-2 mb-8">
              <span className="w-3 h-3 rounded-full bg-primary-500"></span>
              <span className="text-xs font-semibold text-foreground-500 uppercase tracking-widest">Opinie użytkowników</span>
            </div>

            <blockquote className="text-2xl md:text-3xl lg:text-4xl font-heading font-medium text-foreground-950 leading-relaxed">
              <span className="text-primary-400 text-5xl md:text-6xl leading-none">&ldquo;</span>
              <br />
              Kakobuy sheet to najlepsze narzędzie do zakupów z Chin. Oszczędzam czas i pieniądze każdego tygodnia. Znaleziska są zawsze aktualne.
            </blockquote>

            <div className="flex items-center gap-3 mt-6">
              <span className="text-sm font-semibold text-foreground-900">Marcin K.</span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-verified-badge-fill text-primary-500"></i>
              </span>
              <span className="text-xs text-foreground-400">Zweryfikowany Kupujący</span>
            </div>
          </div>

          <div className="flex-shrink-0 w-64 h-80 md:w-80 md:h-96 rounded-3xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20young%20European%20man%20looking%20upward%20thoughtfully%2C%20black%20and%20white%20editorial%20style%2C%20clean%20white%20background%2C%20minimalist%20fashion%20portrait%2C%20soft%20contrast%2C%20modern%20corporate%20headshot%20with%20natural%20expression&width=640&height=768&seq=testimonial-portrait&orientation=portrait"
              alt="Zweryfikowany Kupujący – Opinia Kakobuy Spreadsheet"
              title="Zweryfikowany Kupujący – Kakobuy Spreadsheet"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}